import { render, staticRenderFns } from "./MapPolicyDetail.vue?vue&type=template&id=3699b358"
import script from "./MapPolicyDetail.vue?vue&type=script&lang=js"
export * from "./MapPolicyDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports